<template>
  <div class="w-full mt-4 px-4 overflow-hidden animate-pulse">
    <div
      class="hidden md:grid lg:grid-cols-12 md:grid-cols-6 gap-2 w-full items-center py-2 border-b font-semibold text-gray-700 text-xs md:text-sm bg-gray-50"
    >
      <div class="lg:col-span-2 md:col-span-2">
        <div class="h-4 w-8 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-3 md:col-span-4">
        <div class="h-4 w-32 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-2 md:col-span-3">
        <div class="h-4 w-24 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-2 md:col-span-3">
        <div class="h-4 w-20 bg-slate-200 rounded"></div>
      </div>
      <div class="lg:col-span-3 md:col-span-6">
        <div class="h-4 w-16 bg-slate-200 rounded"></div>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <div
        v-for="n in 5"
        :key="n"
        class="grid lg:grid-cols-12 md:grid-cols-6 grid-cols-1 gap-2 w-full items-center py-4 my-0 border-b border-gray-100 bg-white"
      >
        <div class="lg:col-span-2 md:col-span-2 col-span-12">
          <div class="h-4 w-10 bg-slate-200 rounded"></div>
        </div>
        <div class="lg:col-span-3 md:col-span-4 col-span-12">
          <div class="h-4 w-3/4 bg-slate-200 rounded"></div>
        </div>
        <div class="lg:col-span-2 md:col-span-3 col-span-12">
          <div class="h-4 w-1/2 bg-slate-200 rounded"></div>
        </div>
        <div class="lg:col-span-2 md:col-span-3 col-span-12 flex items-center gap-2">
          <div class="h-8 w-8 rounded-full bg-slate-200"></div>
          <div class="h-4 w-20 bg-slate-200 rounded"></div>
        </div>
        <div class="col-span-12 md:col-span-6 lg:col-span-3 flex gap-4 mt-2 md:mt-0 items-center">
          <div class="h-8 w-8 bg-slate-200 rounded"></div>
          <div class="h-8 w-8 bg-slate-200 rounded"></div>
          <div class="h-6 w-12 bg-slate-200 rounded-full"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
